module.exports = __webpack_public_path__ + "img/img-ind.022cd091.png";